import * as React from "react"
import type { SVGProps } from "react"
const SvgImage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 21.14q-.82 0-1.41-.58A2 2 0 0 1 3 19.13v-14q0-.82.59-1.41A2 2 0 0 1 5 3.14h14q.83 0 1.41.59.6.6.59 1.41v14q0 .82-.59 1.42a2 2 0 0 1-1.41.58zm0-2h14v-14H5zm2-2h10q.3 0 .45-.27a.44.44 0 0 0-.05-.53l-2.75-3.67a.5.5 0 0 0-.4-.2q-.25 0-.4.2l-2.6 3.47-1.85-2.47a.5.5 0 0 0-.4-.2q-.25 0-.4.2l-2 2.67a.44.44 0 0 0-.05.53q.15.27.45.27m1.5-7q.63 0 1.06-.43.45-.45.44-1.07 0-.62-.44-1.06a1.5 1.5 0 0 0-1.06-.44q-.63 0-1.06.44A1.5 1.5 0 0 0 7 8.64q0 .63.44 1.07.43.43 1.06.43" />
  </svg>
)
export default SvgImage
